export default {
	styleOverrides: {
		root: ({ ownerState }) => {
			switch (ownerState.variant) {
				// TODO: would this make more sense as a separate styled component than a variant?
				case 'videoButton':
					return {
						'&.Mui-disabled': {
							backgroundColor: 'rgba(0, 0, 0, 0.42)',
						},
					};
				default:
					return {};
			}
		},
	},
};
